<template>
    <div class="pos-r" v-bind:style="{width: width, height:height}">
        <div v-show="status==1"
             class="textC ys-info-color"
             v-bind:style="{width: width, height:height,lineHeight:height}">
            <div class="d-i-b verticalM">
                <p v-if="no == '1'" v-bind:style="{width: width, height:height,lineHeight:height, color: '#787878'}">暂无数据</p>
                <p v-if="no == '2'"><img style="width: 60%;vertical-align: middle;max-width: 200px;opacity:0.5; "
                                         src="../assets/img/nochart.png" alt=""></p>
            </div>
            <span style="display:none;">{{status}}</span>
        </div>
        <div v-show="status==2">
            <div v-bind:style="{width: width,height:height}">
                <div :id="'feng-bar-gradient-chart-'+id"
                     v-bind:style="{width: width,height:height}"
                     v-on:resize="handleResize($event)">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
    export default {
        name: "bar-gradient",
        props:{
            id: {
                default: 0
            },
            name: {
                default: ""
            },
            tipname: {
                default: "报警线"
            },
            width: {
                default: "100%"
            },
            height: {
                default: "200px"
            },
            color: {
                default: '#2BC5A4'
            },
            x: {
                default:function () {
                    return []
                }
            },
            y: {
                default: ""
            },
            ymax: {
                default: 6
            },
            minline: {
                default: 1
            },
            maxline: {
                default: 5
            },
            unit: {
                default: ''
            },
            no: {
                default: '1'
            },
            dataZoom: {
                default: false
            },
            xAxisText: {
                default: false
            }
        },
        data() {
            return {
            }
        },
        computed: {
            status: function () {
                if (this.y.length > 0) {
                    this.$nextTick(()=>{
                        this.initChart();
                    });
                    return 2
                } else {
                    return 1
                }
            }
        },
        methods: {
            initChart() {
                let self = this;
                let repeat = setInterval(function () {
                    if (document.getElementById('feng-bar-gradient-chart-' + self.id)) {
                        self.setChart();
                        window.addEventListener('resize', self.handleResize)
                        clearInterval(repeat)
                    }
                }, 300)
                let resizeRepeat = setInterval(function () {
                    if (document.getElementById('feng-bar-gradient-chart-' + self.id)) {
                        var EleResize = {
                            _handleResize: function (e) {
                                var ele = e.target || e.srcElement;
                                var trigger = ele.__resizeTrigger__;
                                if (trigger) {
                                    var handlers = trigger.__z_resizeListeners;
                                    if (handlers) {
                                        var size = handlers.length;
                                        for (var i = 0; i < size; i++) {
                                            var h = handlers[i];
                                            var handler = h.handler;
                                            var context = h.context;
                                            handler.apply(context, [e]);
                                        }
                                    }
                                }
                            },
                            _removeHandler: function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    var size = handlers.length;
                                    for (var i = 0; i < size; i++) {
                                        var h = handlers[i];
                                        if (h.handler === handler && h.context === context) {
                                            handlers.splice(i, 1);
                                            return;
                                        }
                                    }
                                }
                            },
                            _createResizeTrigger: function (ele) {
                                var obj = document.createElement('object');
                                obj.setAttribute('style',
                                    'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
                                obj.onload = EleResize._handleObjectLoad;
                                obj.type = 'text/html';
                                ele.appendChild(obj);
                                obj.data = 'about:blank';
                                return obj;
                            },
                            _handleObjectLoad: function (evt) {
                                this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
                                this.contentDocument.defaultView.addEventListener('resize', EleResize._handleResize);
                            }
                        };
                        if (document.attachEvent) {//ie9-10
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    ele.__resizeTrigger__ = ele;
                                    ele.attachEvent('onresize', EleResize._handleResize);
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        ele.detachEvent('onresize', EleResize._handleResize);
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        } else {
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    if (getComputedStyle(ele, null).position === 'static') {
                                        ele.style.position = 'relative';
                                    }
                                    var obj = EleResize._createResizeTrigger(ele);
                                    ele.__resizeTrigger__ = obj;
                                    obj.__resizeElement__ = ele;
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        var trigger = ele.__resizeTrigger__;
                                        if (trigger) {
                                            trigger.contentDocument.defaultView.removeEventListener('resize', EleResize._handleResize);
                                            ele.removeChild(trigger);
                                            delete ele.__resizeTrigger__;
                                        }
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        }
                        var resizeDiv = document.getElementById('feng-bar-gradient-chart-' + self.id);
                        EleResize.on(resizeDiv, function () {
                            self.handleResize();
                        });
                        clearInterval(resizeRepeat)
                    }
                }, 300)
            },
            setChart() {
                let self = this;
                self.chart = this.$echarts.init(document.getElementById('feng-bar-gradient-chart-' + this.id));
                self.option = {
                    title: [
                        {
                            subtext: '{line|—}{text|Min报警线}', 
                            left:'10%',
                            bottom :10,
                            subtextStyle:{
                                color: '#74D9FF',
                                rich:{
                                    line:{
                                        color:'#FF8C00',
                                       
                                    },
                                    text:{
                                        padding: [0, 0, 0, 4]
                                    }
                                }
                            }, 
                        },
                        {
                            subtext: '{line|—}{text|Max报警线}',
                            right:'5%',
                            bottom :10,
                            subtextStyle:{
                                color: '#74D9FF',
                                rich:{
                                    line:{
                                        color:'#EE4F50',
                                    },
                                    text:{
                                        padding: [0, 0, 0, 4]
                                    }
                                }
                            },
                        }
                    ],
                    
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#74D9FF'
                            }
                        },
                        formatter: function (params) {
                            // console.log(params)
                            let str = params[0].name
                            for (var i = 0; i < params.length; i++) {
                                if (self.unit == "band") {
                                    str += "<br/>" + params[i].seriesName + ":" + self.changeUnit(params[i].value)
                                }
                                else if (self.unit == "wan") {
                                    str += "<br/>" + self.tipname + ":" + self.changeWanUnit(params[i].value)
                                } else {
                                    if (self.tipname == "") {
                                        str += "<br/>" + params[i].seriesName + ":" + params[i].value
                                    } else {
                                        str += "<br/>" + self.tipname + ":" + params[i].value
                                    }
                                }
                            }
                            return str
                        },
                    },
                    legend: {
                        x: 'center',
                        top: 10,
                        data: self.x,
                    },
                    grid:{
                        top:'13%',
                        bottom:'20%',
                        left:'12%',
                        right:'5%'
                    },
                    xAxis: {
                        data: self.x,
                        axisLabel: {
                            inside: false,
                        },
                        axisLine: {
                            show: false
                        },
                    },
                    yAxis: {
                        name:'m',
                        nameGap:13,
                        nameTextStyle:{
                            color: '#74D9FF',
                            padding: [0, 0, 0, -19]
                        },
                        splitNumber:4, //坐标轴的分割段数
                        splitLine: {   //分隔线
                            show: true,
                            lineStyle:{
                                type:'dashed',
                                color: '#74D9FF',
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin:3,
                            textStyle: {
                                color: '#74D9FF'
                            }
                        }
                    },
                    series: [
                        { 
                            type: 'bar',
                            itemStyle: {
                                color: 'transparent'
                            },
                            barGap: '-100%',
                            barCategoryGap: '40%',
                            data: [self.ymax],
                            animation: false,
                            markLine : {
                                symbol:"none",               //去掉警戒线最后面的箭头
                                label:{
                                    show:false,
                                    // position:"end",         //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                                    // formatter: "警戒线"
                                },
                                data : [{
                                    silent:false,             //鼠标悬停事件  true没有，false有
                                    lineStyle:{               //警戒线的样式  ，虚实  颜色
                                        type:"solid",
                                        color:"#FF8C00"
                                    },
                                    // name: '警戒线',
                                    yAxis: self.minline
                                },
                                {
                                    silent:false,             //鼠标悬停事件  true没有，false有
                                    lineStyle:{               //警戒线的样式  ，虚实  颜色
                                        type:"solid",
                                        color:"#EE4F50"
                                    },
                                    // name: '警戒线',
                                    yAxis: self.maxline
                                }]
                            }
                        },
                        {
                            type: 'bar',
                            itemStyle: {   // 柱子可做渐变色
                                color: new this.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,this.changeBackgroundColorToWater()
                                )
                            },
                            data: self.y
                        }
                    ],
                };
                self.chart.clear();
                setTimeout(() => {
                    self.chart.setOption(self.option);
                    self.chart.on('click', (params) => {
                        this.$emit('change', params)
                    })
                }, 0);
                
                
            },
            changeBackgroundColorToWater(){
                let backgroundArr = {   // 自定义柱子背景颜色
                    min: [
                        {offset: 0, color: '#FBF3BB'},
                        {offset: 0.5, color: '#E0CA0F'},
                        {offset: 1, color: '#E0CA0F'}
                    ],
                    middle: [
                        {offset: 0, color: '#BBD6FB'},
                        {offset: 0.5, color: '#0F27E0'},
                        {offset: 1, color: '#0F27E0'}
                    ],
                    max: [
                        {offset: 0, color: '#FBBBBB'},
                        {offset: 0.5, color: '#E00F0F'},
                        {offset: 1, color: '#E00F0F'}
                    ]
                }
                let condition = this.y/this.ymax       //柱子高
                let minheight = this.minline/this.ymax //最小警戒线高
                let maxheight = this.maxline/this.ymax //最大警戒线高
                 
                if( condition<= minheight){
                    return backgroundArr.min
                }else if(condition<= maxheight){
                    return backgroundArr.middle
                }else{
                    return backgroundArr.max
                }
            },
            hexToRgba(hex, al) {
                var hexColor = /^#/.test(hex) ? hex.slice(1) : hex, alp = hex === 'transparent' ? 0 : Math.ceil(al), r,
                    g, b;
                hexColor = /^[0-9a-f]{3}|[0-9a-f]{6}$/i.test(hexColor) ? hexColor : 'fffff';
                if (hexColor.length === 3) {
                    hexColor = hexColor.replace(/(\w)(\w)(\w)/gi, '$1$1$2$2$3$3');
                }
                r = hexColor.slice(0, 2);
                g = hexColor.slice(2, 4);
                b = hexColor.slice(4, 6);
                r = parseInt(r, 16);
                g = parseInt(g, 16);
                b = parseInt(b, 16);
                return {
                    hex: '#' + hexColor,
                    alpha: alp,
                    rgba: 'rgba(' + r + ', ' + g + ', ' + b + ', ' + (alp / 100).toFixed(2) + ')'
                };
            },
            changeWanUnit(val) {
                if (val < 10000) {
                    return val + "条"
                } else {
                    val = (val / 10000).toFixed(2);
                    return val + "万条"
                }
            },
            changeUnit(val) {
                if (val < 1024) {
                    return val + "b"
                } else if (val >= 1024 && val < 1024 * 1024) {
                    val = (val / 1024).toFixed(1);
                    return val + "Kb"
                } else if (val >= 1024 * 1024 && val < 1024 * 1024 * 1024) {
                    val = (val / (1024 * 1024)).toFixed(1);
                    return val + "Mb"
                } else if (val >= 1024 * 1024 * 1024) {
                    val = (val / (1024 * 1024 * 1024)).toFixed(1);
                    return val + "Gb"
                }
            },
            handleResize() {
                this.chart.resize();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/bar-gradient.vue